import { AspectRatio, Center, forwardRef, Icon, Skeleton, Stack, Text } from '@chakra-ui/react'
import React, { useState } from 'react'
import { RiImageFill } from 'react-icons/ri'
import GCSImage from './GCSImage'

const RatioImage = forwardRef(({
  src,
  ratio,
  alt,
  onLoad,
  size,
  isEditing,
  isPreview,
  isDisabled,
  skeleton = true,
  compact,
  ...props
}, ref) => {
  const placeholder = (isEditing || isPreview) ? (
    <AspectRatio ref={ref} ratio={ratio} opacity={isDisabled ? 0.4 : 1} {...props}>
      <Center bg="gray.100">
        <Stack alignItems="center">
          <Icon as={RiImageFill} width="2em" height="2em" />
          {!compact && <Text fontSize="sm">{isDisabled ? '圖片已隱藏' : '請上傳圖片'}</Text>}
        </Stack>
      </Center>
    </AspectRatio>
  ) : null
  if (isDisabled) return placeholder
  return src ? (
    <AspectRatio
      ratio={ratio}
      ref={ref}
      transform="translateZ(0)"
      {...props}
    >
      <GCSImage
        src={src}
        alt={alt}
        size={size}
        onLoad={onLoad}
      />
    </AspectRatio>
  ) : placeholder
})

RatioImage.defaultProps = {
  overflow: 'hidden',
}

export default RatioImage
